import { render, staticRenderFns } from "./default-model.vue?vue&type=template&id=6d02c99f&"
import script from "./default-model.vue?vue&type=script&lang=js&"
export * from "./default-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports